var NEXTIVA_DEV_URL = 'https://dev.dev.nextiva.xyz';
var NEXTIVA_JS_MODULES_URL = 'https://js-modules.nextiva.xyz';
export var ANALYTICS_API_PUBLIC_PATH = location.origin === NEXTIVA_JS_MODULES_URL ? NEXTIVA_DEV_URL + "/api/analytics" : '/api/analytics';